// @core/api/endpoints/task/register_task_type.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  RegisterTaskTypeRequest,
  TaskTypeDefinitionResponse,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Register task type
 * Registers a new task type definition. Products call this to declare their task-aware entity types (e.g., staffing.shift_assignment, property.maintenance). Once registered, TaskService will handle status tracking, assignment, and time tracking for entities of this type.
 */
export async function RegisterTaskType(
  data: RegisterTaskTypeRequest,
  options?: RequestOptions
): Promise<TaskTypeDefinitionResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/task-types`;
  const requestOptions = options;
  return client.post<TaskTypeDefinitionResponse>(requestPath, data, requestOptions);
}
